// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"f90866e7","376":"b8478cb9","459":"859c889f","591":"c3dfb0b6","774":"59d1ea7b","787":"1d7729fd","813":"cfe07729","883":"c46946d6"}[chunkId] + ".chunk.js";
};